var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kanban-board" },
    [
      _c(
        "div",
        {
          staticClass: "minimap-container",
          class: { "minimap-collapsed": _vm.minimapCollapsed },
        },
        [
          _c(
            "div",
            { staticClass: "minimap-toggle", on: { click: _vm.toggleMinimap } },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v(
                  _vm._s(_vm.minimapCollapsed ? "unfold_more" : "unfold_less")
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.minimapCollapsed,
                  expression: "!minimapCollapsed",
                },
              ],
              staticClass: "minimap-content",
            },
            [
              _c(
                "div",
                {
                  staticClass: "minimap-slider",
                  style: {
                    left: _vm.scrollBarPosition + "px",
                    width: _vm.scrollBarWidth + "px",
                  },
                  on: { mousedown: _vm.startDragging },
                },
                [
                  _c("div", { staticClass: "material-icons" }, [
                    _vm._v("visibility"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "minimap-scroll" },
                _vm._l(_vm.filteredPipelines, function (pipeline) {
                  return _c(
                    "a-tooltip",
                    {
                      key: pipeline._id,
                      attrs: {
                        placement: "top",
                        title: pipeline.name,
                        color: pipeline.color || "#1890ff",
                      },
                    },
                    [
                      _c("div", {
                        staticClass: "minimap-item",
                        style: { backgroundColor: pipeline.color || "#1890ff" },
                        on: {
                          click: function ($event) {
                            return _vm.scrollToPipeline(pipeline._id)
                          },
                        },
                      }),
                    ]
                  )
                }),
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "draggable",
        {
          key: _vm.workflowId + "_" + _vm.renderKey,
          staticClass: "supsis-draggable",
          attrs: {
            options: _vm.taskGroupDragOptions,
            draggable: ".drag-pipeline-columns",
          },
          on: { start: _vm.handleDragStart, end: _vm.movePipelineEnd },
          model: {
            value: _vm.pipelines,
            callback: function ($$v) {
              _vm.pipelines = $$v
            },
            expression: "pipelines",
          },
        },
        [
          _c(
            "transition-group",
            { staticClass: "drag-container", attrs: { tag: "div" } },
            _vm._l(_vm.filteredPipelines, function (pipeline) {
              return _c("TaskColumnCard", {
                key: pipeline._id,
                ref: "pipeline_" + pipeline._id,
                refInFor: true,
                attrs: {
                  pipelineLoaded: _vm.pipelineLoaded,
                  pipelines: _vm.pipelines,
                  pipeline: pipeline,
                  moving: _vm.moving,
                  workflowId: _vm.workflowId,
                  tasks: _vm.tasks[pipeline._id],
                  checkedItems: _vm.checkedItems,
                  basicTaskForm: _vm.basicTaskForm,
                },
                on: {
                  loadMoreTask: _vm.loadMoreTask,
                  updateCheckedItems: function ($event) {
                    return _vm.$emit("updateCheckedItems", $event)
                  },
                  createdTask: function ($event) {
                    return _vm.createdTask(pipeline._id, $event)
                  },
                  updateBasicTaskForm: function ($event) {
                    return _vm.$emit("updateBasicTaskForm", $event)
                  },
                  resetActions: _vm.resetActions,
                  "close-create-mode": _vm.closeCreateMode,
                  moved: _vm.moveActionEnd,
                  "pipeline-form": _vm.createPipelineForm,
                  "create-pipeline": _vm.createPipeline,
                  "update-pipeline": _vm.updatePipeline,
                  "pipeline-deleted": _vm.handlePipelineDeleted,
                  "delete-modal-task": _vm.openDeleteTaskModal,
                  "confirm-modal-task": _vm.confirmModalOpen,
                  "archived-modal-task": _vm.archivedModalOpen,
                  "change-workflow-task": _vm.changeWorkflowTask,
                  "to-completed-task": _vm.toCompletedTask,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.deleteTaskModal
        ? _c("DeleteModal", {
            attrs: {
              description: _vm.$t("task.deleteTaskCont"),
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("message.delete"),
            },
            on: {
              cancel: function ($event) {
                _vm.deleteTaskModal = false
              },
              confirm: _vm.softDeleteTask,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmTaskModal
        ? _c("ConfirmModal", {
            attrs: {
              description: _vm.$t("task.sureAddCompletedList"),
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("message.yes"),
            },
            on: {
              cancel: function ($event) {
                _vm.confirmTaskModal = false
              },
              confirm: _vm.confirmTask,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "Görev Kapatma İşlemi",
            closable: true,
            maskClosable: true,
            okText: "Onayla",
            cancelText: "İptal",
            okButtonProps: {
              type: "primary",
              style: { backgroundColor: "#ec4b1d", borderColor: "#ec4b1d" },
            },
          },
          on: {
            ok: _vm.simpleDoneTask,
            cancel: function ($event) {
              _vm.simpleConfirmModal = false
            },
          },
          model: {
            value: _vm.simpleConfirmModal,
            callback: function ($$v) {
              _vm.simpleConfirmModal = $$v
            },
            expression: "simpleConfirmModal",
          },
        },
        [
          _c("div", { staticClass: "simple-confirm-modal-content" }, [
            _c("div", { staticClass: "modal-icon" }, [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v("check_circle"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-message" }, [
              _c("p", [_vm._v("Görevi kapatmak istediğinize emin misiniz?")]),
              _vm._v(" "),
              _c("p", { staticClass: "modal-description" }, [
                _vm._v(
                  "\n                    Bu görev tamamlanmış olarak işaretlenecek ve aktif görevler listesinden kaldırılacaktır.\n                "
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.archivedTaskModal
        ? _c("TaskArchiveModal", {
            attrs: {
              description: "Görevi Arşivlemek İstediğinize Emin Misiniz?",
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("message.yes"),
            },
            on: {
              cancel: function ($event) {
                _vm.archivedTaskModal = false
              },
              confirm: _vm.archiveModalTask,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Change Workflow" },
          on: { ok: _vm.handleChangeWorkflow, cancel: _vm.handleCancel },
          model: {
            value: _vm.changeWorkflowModal,
            callback: function ($$v) {
              _vm.changeWorkflowModal = $$v
            },
            expression: "changeWorkflowModal",
          },
        },
        [
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "Select a workflow" },
              model: {
                value: _vm.selectedWorkflow,
                callback: function ($$v) {
                  _vm.selectedWorkflow = $$v
                },
                expression: "selectedWorkflow",
              },
            },
            _vm._l(_vm.workflows, function (workflow) {
              return _c(
                "a-select-option",
                { key: workflow._id, attrs: { value: workflow._id } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(workflow.title) +
                      "\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("div", { staticClass: "loading-overlay" }, [
            _c("div", { staticClass: "loading-content" }, [
              _c("div", { staticClass: "loading-spinner" }),
              _vm._v(" "),
              _c("div", { staticClass: "loading-text" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.loading")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "loading-subtext" }, [
                _vm._v(
                  "\n                Görevler yükleniyor, lütfen bekleyiniz...\n            "
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }